/**
 * Current velocity display.
 */

import styles from './GameHUD.module.css';

interface SpeedometerProps {
  readonly vx: number;
  readonly vy: number;
}

export function Speedometer({ vx, vy }: SpeedometerProps) {
  const speed = Math.sqrt(vx * vx + vy * vy);
  return (
    <div className={styles.speedContainer}>
      <span className={styles.hudLabel}>SPEED</span>
      <span className={styles.hudValue}>{speed.toFixed(1)}</span>
    </div>
  );
}
